import React from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
const coverageAreas = [{
  name: "BEWEI BODY",
  imageUrl: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-050-scaled.jpg?v=y2zzcmwfw07",
  alt: "BEWEI BODY treatment session"
}, {
  name: "BEWEI HANDS",
  imageUrl: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-elfenbein-elfenbein124-scaled.jpg?v=35gq26tvu9m",
  alt: "BEWEI HANDS specialized care"
}, {
  name: "BEWEI FACE",
  imageUrl: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-033-scaled.jpg?v=fd7yl6jgrde",
  alt: "BEWEI FACE rejuvenation"
}, {
  name: "Lymphdrainage",
  imageUrl: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-132-scaled.jpg?v=m0ja3huqq0o",
  alt: "Professional Lymphdrainage therapy"
}, {
  name: "Schlank im Liegen",
  imageUrl: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-057-scaled.jpg?v=phsybwvuckd",
  alt: "Schlank im Liegen body contouring"
}, {
  name: "EMP Chair",
  imageUrl: "https://stable-sturgeon.10web.cloud/wp-content/uploads/2026/05/EMP-Chair-Pro-one-anthrazit-073-scaled.jpg?v=2p3ns6yun6u",
  alt: "EMP Chair pelvic floor training"
}];
export default function ShippingCoverage() {
  return <section data-section-id="256341" id="treatmentcarousel" className="bg-background text-foreground overflow-hidden ![padding:0px_0px_-1px_0px] md:!h-[400px]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 md:mb-12 text-center md:text-left">
          {}
        </div>

        <div className="relative px-0 md:px-12 md:h-screen">
          <Carousel opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="flex -ml-4 py-4 w-full md:-ml-6">
              {coverageAreas.map((area, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 basis-full sm:basis-1/2 md:basis-1/3 lg:basis-1/4 xl:basis-1/5">
                  <div className="flex flex-col gap-4 group">
                    <div className="overflow-hidden rounded-lg shadow-md transition-shadow duration-500 group-hover:shadow-xl">
                      <img src={area.imageUrl} alt={area.alt} data-wvc-srcset={`${area.imageUrl}-wvc-srcset`} data-wvc-sizes={`${area.imageUrl}-wvc-sizes`} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <CarouselPrevious className="rounded-lg hidden md:flex -left-4 lg:-left-12 bg-background border-border text-primary hover:bg-accent hover:text-accent-foreground transition-all duration-300 shadow-sm" />
            <CarouselNext className="rounded-lg hidden md:flex -right-4 lg:-right-12 bg-background border-border text-primary hover:bg-accent hover:text-accent-foreground transition-all duration-300 shadow-sm" />
          </Carousel>
        </div>
      </div>
    </section>;
}